import {
  MORPHEUS_3_WAY_CHAT_KEYWORDS_FEATURE_FLAG,
  useFeatureFlag,
} from 'featureFlags';

import { hasKeywords } from 'features/chat/utils/keywordDetection';

export const useHasKeywords = () => {
  const keywords = useFeatureFlag(
    MORPHEUS_3_WAY_CHAT_KEYWORDS_FEATURE_FLAG
  ) as unknown as string || '';

  return (text: string) => hasKeywords(text, keywords);
};
